<template>
  <div class="w-100 p-2 mt-2">
    <page-header>
      <i class="fas fa-list"></i> {{ $t('page.title.question_categories') }}
      <template v-slot:right>
        <b-button @click="openModal('create')" variant="success">{{ $t('btn.add_new') }}</b-button>
      </template>
    </page-header>
    <page-card>
      <template v-slot:header>
        {{ $t('page.filters') }}
      </template>
      <template v-slot:content>
        <div class="sygni-grid">
          <div class="row">
            <div class="col-4">
              <filter-input
                  :filter-query="filterQuery"
                  filter-name="phrase"
                  :label="$t('filters.label.question_category_phrase')"
                  :placeholder="$t('filters.placeholder.question_category_phrase')">
              </filter-input>
            </div>
            <div class="col-4">
              <filter-input-with-operator
                  :filter-query="filterQuery"
                  :operator-options="selectOptions.comparisonOperator"
                  :operator-multiple="false"
                  :default-operator="{value: 'eq', text: $t('operator.equales')}"
                  filter-name="questionCount"
                  :label="$t('filters.label.question_count')"
                  :single-value-placeholder="$t('filters.placeholder.question_count')">
              </filter-input-with-operator>
            </div>
            <div class="col-4">
              <filter-date-range-picker
                  :filter-query="filterQuery"
                  :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                  :auto="true"
                  :linked="false"
                  :time-picker="true"
                  filter-name="created_at"
                  open-direction="left"
                  :label="$t('filters.label.created_at')">
              </filter-date-range-picker>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <b-button @click="resetFilters()" variant="secondary">{{$t('filters.btn.clear')}}</b-button>
        <b-button @click="applyFilters()" variant="primary">{{$t('filters.btn.apply')}}</b-button>
      </template>
    </page-card>

    <page-card>
      <template v-slot:header>
        {{ $t('page.list') }}
      </template>
      <template v-slot:content>
        <div class="sygni-grid">

          <div class="col-12">
          </div>
          <div class="col-12">
            <grid-pagination :total-count="totalCount"
                             :per-page="perPage"
                             :current-page="currentPage"
                             @load-items="paginationReload"></grid-pagination>
          </div>

          <div class="table-responsive">
            <b-table striped show-empty
                     :empty-text="$t('table.no_results')"
                     :busy="isBusy"
                     hover
                     head-variant="dark"
                     outlined
                     :sort-by.sync="orderColumn"
                     :sort-desc.sync="orderDirection"
                     :no-local-sorting="true"
                     :items="items"
                     :fields="fields">

              <template #cell(id)="data">
                {{ data.value | shortId }}
              </template>

              <template #cell(name)="data">
                {{ $t('category.'+data.value.toString().trim().replaceAll(' ', '_').replaceAll("'", '').toLowerCase()) }}
              </template>

              <template #cell(created_at)="data">
                <div class="table-flag--wrapper">
                  <div>{{ data.item.createdAt | date }}</div>
                </div>
              </template>

              <template #cell(actions)="data">
                <div class="table-action--cell">
                  <b-button variant="success" size="sm"
                            @click="openModal('create', data.item)">
                    {{ $t('table.btn.edit') }}
                  </b-button>
                  <b-button variant="danger" size="sm"
                            @click="deleteItem(data.item)">
                    {{ $t('table.btn.delete') }}
                  </b-button>
                </div>
              </template>

              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>{{$t('state.loading')}}</strong>
                </div>
              </template>
            </b-table>
          </div>


          <div class="col-12">
            <grid-pagination :total-count="totalCount"
                             :per-page="perPage"
                             :current-page="currentPage"
                             @load-items="paginationReload"></grid-pagination>
          </div>
        </div>
      </template>
      <template v-slot:footer>

      </template>
    </page-card>
  </div>
</template>

<script>
import FilterInput from "../../components/grid/filters/FilterInput";
import FilterInputWithOperator from "../../components/grid/filters/FilterInputWithOperator";
import FilterDateRangePicker from "../../components/grid/filters/FilterDateRangePicker";
import GridMixin from '../../components/grid/GridMixin';
import CreateQuestionCategoryModal from "./CreateQuestionCategoryModal";
import axios from "axios";
import GridPagination from "../../components/grid/grid-pagination/GridPagination";
import PageHeader from "../../components/page/PageHeader";
import PageCard from "../../components/page/PageCard";
import Vue from "vue";

export default {
  mixins: [GridMixin],
  components: {
    PageCard,
    PageHeader,
    GridPagination,
    FilterInput,
    FilterInputWithOperator,
    FilterDateRangePicker
  },
  data() {
    return {
      gridGetUrl: '/api/question/question-category',
      categoryGetUrl: '/api/question/question-category',
      localeGetUrl: '/api/backoffice/locale',
      showDeleted: false,
      orderColumn: 'name',
      orderDirection: true,
      items: [],
      fields: [
        {key: 'id'},
        {key: 'name', label: this.$t('table.header.category_name'), sortable: true},
        {key: 'questionCount', label: this.$t('table.header.question_count'), sortable: true},
        {key: 'created_at', label: this.$t('table.header.created_at'), sortable: true},
        {key: 'actions', label: this.$t('table.header.actions'), thClass: 'text-right'},
      ],
      selectOptions: {
        comparisonOperator: [
          {value: 'eq', text: this.$t('operator.equales')},
          {value: 'gte', text: this.$t('operator.greater_then')},
          {value: 'lte', text: this.$t('operator.lower_than')},
          {value: 'btw', text: this.$t('operator.between')},
        ]
      },
      createQuestionCategoryModalInstance: null,
    };
  },
  methods: {
    getLocale() {
      this.getData(this.localeGetUrl, ['selectOptions', 'lang']);
    },
    editItem(item) {
      this.$refs['create-edit-category-modal'].openModal(item);
    },
    deleteItem(item) {
      this.$bvModal.msgBoxConfirm('Question category: ' + item.name, {
        title: 'Are you sure to delete question category?',
        okTitle: 'Delete',
        cancelTitle: 'Cancel',
        okVariant: 'danger',
      })
          .then(value => {
            if (value) {
              axios.delete('/api/question/question-category/' + item.id)
                  .then(() => {
                    this.loadItems();
                  })
                  .catch(error => {
                    console.log(error);
                  });
            }
          });
    },
    openModal(modalName, data) {
      let ModalConstructor;
      switch (modalName) {
        case('create'): {
          if (!this.createQuestionCategoryModalInstance) {
            ModalConstructor = Vue.extend(CreateQuestionCategoryModal)
            this.createQuestionCategoryModalInstance = new ModalConstructor({parent: this});
            this.createQuestionCategoryModalInstance.$data.apiKey = this.apiKey;
            this.createQuestionCategoryModalInstance.$data.items = this.items;
            this.createQuestionCategoryModalInstance.$data.selectOptions = this.selectOptions;
            this.createQuestionCategoryModalInstance.$mount();
            this.createQuestionCategoryModalInstance.$on('removedIcon', this.loadItems);
          }
          this.createQuestionCategoryModalInstance.openModal(data);
          break;
        }
      }
    }
  },
  watch: {
    showDeleted: function () {
      this.toggleDeletedAmongStatuses();
      this.loadItems()
    }
  }
}
</script>
